export enum AdminTab {
  User = 'Userverwaltung',
  IntroTexts = 'Introtext Vorlagen',
  Regions = 'Regionen Raster',
  PersonGroups = 'Personengruppen',
  DevTools = 'Dev-Tools'
}
